<template>
    <l-tile-layer :url="url">
        <slot />
    </l-tile-layer>
</template>

<script>
import { LTileLayer } from "vue2-leaflet"

export default {
    components: { LTileLayer },
    props: {
        url: { type: String, default: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' },
    },
}
</script>